import React from 'react';
import {observer} from 'mobx-react';

import {ACTION_TYPES} from "../../../../core/consts";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {ENTITY_TYPES, STANDINGS_TABS} from "../../../../core/app/consts";
import {SeeAllFooterWidget} from "../../../../core/components/see-all-footer/see-all-footer";
import {StandingsWidgetController} from "../../standings-widget.controller";

export class StandingsWidgetSeeAllFooterProps extends BaseProps {
  controller: StandingsWidgetController;
  collapsedCompetitorIds: Array<Number>;
  source: String;
}

export const StandingsWidgetSeeAllFooter = observer(({
                                                       source,
                                                       controller,
                                                       collapsedCompetitorIds,
                                                     }: StandingsWidgetSeeAllFooterProps) => {
  const {state, device} = controller;
  const {
    footerLinkModel,
    footerLabel,
    competitorId,
    highlightedRowsIds,
    footerRouteProps,
    currentLinkModel
  } = state;


  const seeAllFooterProps = {
    competitorId,
    highlightedRowsIds,
    collapsedCompetitorIds,
    linkModel: footerLinkModel,
    buttonLabel: footerLabel,
    isRtl: device.isRtl,
    onClick: () => onStandingsClick(),
    routeProps: footerRouteProps,
    shouldSendAnalyticsEvent: true,
    controller,
    source,
    currentLinkModel,
  }

  const onStandingsClick = () => {
    controller.action(ACTION_TYPES.standingsClick, {
      entityType: ENTITY_TYPES.competition,
      entityId: state.competition.id,
      source: source,
      standingsTab: STANDINGS_TABS.all,
      sportTypeId: state.competition.sportId
    });

    return true;
  }

  return state.shouldRenderFooterButton ? <SeeAllFooterWidget {...seeAllFooterProps}/> : null;
});
